import { restGet, restPost, restPut } from "apiCommandsExecutor/rest";

import { InvoiceServiceOrderDto, PaymentsPageDto, ServiceOrderDto } from "./restModels";
import { PaymentsListParams, UpdateInvoiceStatusRequestDto } from "./restRequests";

export const getServiceOrders = (organizationBranchId: number) =>
    restGet<ServiceOrderDto[]>("/service-orders", { organizationBranchId });

export const getPayments = (params: PaymentsListParams) =>
    restGet<PaymentsPageDto>("/service-orders/payments", {
        from: params.from,
        to: params.to,
        partnerId: params.partnerId || undefined,
        skip: params.skip,
        limit: params.limit,
    });

export const generateInvoiceDocument = (invoiceId: string) =>
    restPost<InvoiceServiceOrderDto>(`/service-orders/invoices/${invoiceId}/document`);

export const generateInvoiceAct = (invoiceId: string) =>
    restPost<InvoiceServiceOrderDto>(`/service-orders/invoices/${invoiceId}/act`);

export const updateInvoiceStatus = (invoiceId: string, body: UpdateInvoiceStatusRequestDto) =>
    restPut<InvoiceServiceOrderDto>(`/service-orders/invoices/${invoiceId}/status`, body);
